import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

document.addEventListener('DOMContentLoaded', () => {
  const yOffset = -70;

  document.querySelectorAll('.terms-of-use a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function onClick(e) {
      e.preventDefault();

      const element = document.querySelector(this.getAttribute('href'));
      const scrollTo = element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({
        top: scrollTo,
        behavior: 'smooth',
      });
    });
  });

  const StickyCategories = React.lazy(() => import('../homepage/components/sticky_categories/StickyCategories'));
  createRoot(
    document.getElementById('react-sticky-categories'),
  ).render(
    <Suspense fallback="">
      <Provider store={window.store}>
        <StickyCategories />
      </Provider>
    </Suspense>,
  );
});
